import { render, staticRenderFns } from "./v-pagination-dots.vue?vue&type=template&id=49dec0da&scoped=true&"
import script from "./v-pagination-dots.vue?vue&type=script&lang=js&"
export * from "./v-pagination-dots.vue?vue&type=script&lang=js&"
import style0 from "./v-pagination-dots.vue?vue&type=style&index=0&id=49dec0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dec0da",
  null
  
)

export default component.exports